<script setup lang="ts">
import VIcon from '@/components/template/v-icon.vue'
import { ref } from 'vue'
import useLogout from '@/composables/useLogout'

const { logoutAndRedirect } = useLogout()

let isPopupShow = ref(false)
let popupCnt = 0

const hidePopup = () => {
  isPopupShow.value = false
  document.removeEventListener('click', popupEvent)
  popupCnt = 0
}

const popupEvent = (e: Event) => {
  const targets = document.querySelectorAll('.alert-notification')
  const arr = Array.prototype.slice.call(targets)
  if (
    isPopupShow.value &&
    e.target != document.getElementById('account_menu') &&
    arr.indexOf(e.target) == -1
  ) {
    if (popupCnt != 0) {
      togglePopup()
    } else {
      popupCnt++
    }
  }
}

const togglePopup = () => {
  if (!isPopupShow.value) {
    isPopupShow.value = true
    document.addEventListener('click', popupEvent)
  } else {
    hidePopup()
  }
}
</script>

<template>
  <div class="h-full">
    <div class="wrap-content flex flex-col h-full">
      <div class="h-12 shadow-md z-30 hidden sm:block">
        <div class="flex justify-between">
          <div id="content" class="ml-3 flex flex-wrap content-center">
            <router-link :to="{ name: 'vehiclesMap' }" class="py-2">
              <img
                class="h-8 w-8"
                src="/images/favicons/favicon-32x32.png"
                alt="Workflow"
              />
            </router-link>
          </div>
          <div class="pr-3 flex flex-wrap content-center">
            <div>
              <button @click="togglePopup()" data-test="right-menu-toggle">
                <v-icon
                  icon="account_circle"
                  :outlined="true"
                  class="text-3xl inline-block align-top"
                />
              </button>
              <div
                v-if="isPopupShow"
                id="account_menu"
                class="absolute right-0 bg-white border-2 rounded-md py-1 px-2"
              >
                <div
                  class="cursor-pointer flex"
                  @click="logoutAndRedirect()"
                  data-test="logout-btn"
                >
                  <v-icon icon="logout" class="text-lg" />
                  <div class="pl-2 pt-0.5">
                    {{ $t('pages.mainTemplate.logoutBtn') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <router-view />
    </div>
  </div>
</template>

<style scoped></style>
